export enum MediaTypes {
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
}
export function CheckMediaType(url: any) {
    // Define video and image file extensions
    const videoExtensions = ['.mp4', '.mov', '.avi', '.wmv', '.flv', '.mkv', '.webm', '.3gp', '.ogg', '.m4v', '.mpeg', '.ts'];
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.tiff', '.svg', '.ico'];

    // Extract the file extension
    const extension = url?.split('.')?.pop()?.toLowerCase();

    // Check the file type
    if (videoExtensions.includes(`.${extension}`)) {
        return MediaTypes.VIDEO;
    } else {
        return MediaTypes.IMAGE;
    }

}